// extracted by mini-css-extract-plugin
export var menuContainer = "Menu-module--menuContainer--j_bHf";
export var openMenu = "Menu-module--openMenu--2L6E6";
export var langSelector = "Menu-module--langSelector--25B4Z";
export var lang = "Menu-module--lang--1NGEw";
export var selectedLang = "Menu-module--selectedLang--dfdcN";
export var menuButton = "Menu-module--menuButton--gRUgg";
export var arrowIcon = "Menu-module--arrowIcon--1gPeg";
export var menuContent = "Menu-module--menuContent--2pkAz";
export var content = "Menu-module--content--1ZUB-";
export var homeButton = "Menu-module--homeButton--1M6tT";
export var gameDescription = "Menu-module--gameDescription--ZHw2G";